import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import HeaderPrimary from './components/HeaderPrimary';
import HeaderSecondary from './components/HeaderSecondary';
import routes from './routes';
import Application from '../common/Application';
import Navigation from '../common/components/Navigation';
import AdminNav from './components/AdminNav';
import AdminRegistry from './utils/AdminRegistry';
import SearchManager from '../common/SearchManager';
import SearchState from '../common/states/SearchState';
import BasicsPage from './components/BasicsPage';
import GeneralSearchIndex from './states/GeneralSearchIndex';
import AppearancePage from './components/AppearancePage';
import MailPage from './components/MailPage';
import AdvancedPage from './components/AdvancedPage';
import PermissionsPage from './components/PermissionsPage';
export let DatabaseDriver = /*#__PURE__*/function (DatabaseDriver) {
  DatabaseDriver["MySQL"] = "MySQL";
  DatabaseDriver["PostgreSQL"] = "PostgreSQL";
  DatabaseDriver["SQLite"] = "SQLite";
  return DatabaseDriver;
}({});
export default class AdminApplication extends Application {
  constructor() {
    super();
    /**
     * Stores the available settings, permissions, and custom pages of the app.
     * Allows the global search to find these items.
     *
     * @internal
     */
    _defineProperty(this, "registry", new AdminRegistry());
    _defineProperty(this, "extensionCategories", {
      feature: 30,
      theme: 20,
      language: 10
    });
    _defineProperty(this, "history", {
      canGoBack: () => true,
      getCurrent: () => null,
      getPrevious: () => null,
      push: () => {},
      backUrl: () => this.forum.attribute('baseUrl'),
      back: function () {
        window.location.assign(this.backUrl());
      },
      home: () => {}
    });
    _defineProperty(this, "search", new SearchManager(new SearchState()));
    /**
     * Custom settings and custom permissions do not go through the registry.
     * The general index is used to manually add these items to be picked up by the search.
     */
    _defineProperty(this, "generalIndex", new GeneralSearchIndex());
    /**
     * Settings are serialized to the admin dashboard as strings.
     * Additional encoding/decoding is possible, but must take
     * place on the client side.
     *
     * @inheritdoc
     */
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "route", void 0);
    routes(this);
    this.route = Object.getPrototypeOf(Object.getPrototypeOf(this)).route.bind(this);
  }
  runBeforeMount() {
    BasicsPage.register();
    AppearancePage.register();
    MailPage.register();
    AdvancedPage.register();
    PermissionsPage.register();
    super.runBeforeMount();
  }

  /**
   * @inheritdoc
   */
  mount() {
    // Mithril does not render the home route on https://example.com/admin, so
    // we need to go to https://example.com/admin#/ explicitly.
    if (!document.location.hash) document.location.hash = '#/';
    m.route.prefix = '#';
    super.mount();
    m.mount(document.getElementById('app-navigation'), {
      view: () => m(Navigation, {
        className: "App-backControl",
        drawer: true
      })
    });
    m.mount(document.getElementById('header-navigation'), Navigation);
    m.mount(document.getElementById('header-primary'), HeaderPrimary);
    m.mount(document.getElementById('header-secondary'), HeaderSecondary);
    m.mount(document.getElementById('admin-navigation'), AdminNav);
  }
  getRequiredPermissions(permission) {
    const required = [];
    if (permission === 'startDiscussion' || permission.indexOf('discussion.') === 0) {
      required.push('viewForum');
    }
    if (permission === 'discussion.delete') {
      required.push('discussion.hide');
    }
    if (permission === 'discussion.deletePosts') {
      required.push('discussion.hidePosts');
    }
    if (permission === 'user.editGroups') {
      required.push('viewHiddenGroups');
    }
    return required;
  }
}